import React from "react";
import MenuButton from "./MenuButton";
import "../../css/menu.css";
import AbstractMenu from "./AbstractMenu";
import SubmenuHeader from "./SubMenuHeader";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import DailyClosing from "../../reports/DailyClosing";
import TableOccupations from "../../reports/TableOccupations";
import OrderSummary from "../../orders/OrderSummary";
import Report from "../../reports/Report";
import MenuChangeLog from "../../admin/MenuChangeLog";
import auth, { get, getGlobal, startpoll } from "../../js/auth";
import CanAccess from "../CanAccess";
import { hasRole } from "../../js/admin";

class ReportsMenu extends AbstractMenu {
  state = {
    reports: [],
    loggedIn: undefined,
  };

  dashboardRequestInFlight = false;

  request = req => new Promise((resolve, reject) => req.done(resolve).fail(reject));

  loginToSuperset = async restaurantId => {
    const loginUrl = id => `https://superset.eatwithme.online/loginewm2/${id}`;
    const tokenUrl = id => `login/getLoginTokenNew/${restaurantId}?l=supersetlogin`;

    try {
      const token = await this.request(getGlobal(tokenUrl(restaurantId), undefined, undefined, undefined, false, true));
      await this.request(get(`${loginUrl(restaurantId)}/${token.token}`, undefined, undefined, undefined, false, true));
      return true;
    } catch (error) {
      auth.ajaxError = false;
      try {
        const token = await this.request(getGlobal(tokenUrl(restaurantId), undefined, undefined, undefined, false, true));
        await new Promise(resolve => setTimeout(resolve, 1000));
        await this.request(get(`${loginUrl(restaurantId)}/${token.token}`, undefined, undefined, undefined, false, true));
        return true;
      } catch (retryError) {
        auth.ajaxError = false;
        return false;
      }
    }
  }

  getDashboards = async () => {
    if (!this.props?.myStatus?.restaurant_name || this.state.superSetReports) return;

    if (this.dashboardRequestInFlight) {
      return;
    }

    this.dashboardRequestInFlight = true;
    const name = this.props.myStatus.restaurant_name;
    const escapedName = name.replace(/'/g, "%").replace(/&/g, "%"); // Escape single quotes in the name
    const url = `https://superset.eatwithme.online/api/v1/dashboard/?q=(filters:!((col:dashboard_title,opr:title_or_slug,value:'${escapedName}')),order_column:changed_on_delta_humanized,order_direction:desc,page:0,page_size:25,select_columns:!(id,dashboard_title,published,url,slug,changed_by,changed_on_delta_humanized,owners.id,owners.first_name,owners.last_name,owners,tags.id,tags.name,tags.type,status,certified_by,certification_details,changed_on))`;

    try {
      const loadDashboards = async () => {
        const data = await this.request(get(url, undefined, undefined, undefined, false));

        if (data.result.length > 0) {
          this.setState({ superSetReports: data.result.filter(r => r.slug && r.slug.startsWith(localStorage.instance + "_")) });
          return true;
        }

        return false;
      };

      const hasDashboards = await loadDashboards();
      if (hasDashboards) {
        return;
      }

      if (this.state.loggedIn === undefined && this.props.myStatus.email && hasRole("reports.bi")) {
        this.setState({ loggedIn: false });
        const loggedIn = await this.loginToSuperset(this.props.myStatus.restaurant_global_id);
        if (loggedIn) {
          this.setState({ loggedIn: true });
          await loadDashboards();
        }
      }
    } catch (error) {
      auth.ajaxError = false;
      const shouldTryLogin = this.state.loggedIn !== false;

      if (this.state.loggedIn !== false) {
        this.setState({ loggedIn: false });
      }

      if (shouldTryLogin) {
        const loggedIn = await this.loginToSuperset(this.props.myStatus.restaurant_global_id);
        if (loggedIn) {
          this.setState({ loggedIn: true });
          const data = await this.request(get(url, undefined, undefined, undefined, false));
          if (data.result.length > 0) {
            this.setState({ superSetReports: data.result.filter(r => r.slug && r.slug.startsWith(localStorage.instance + "_")) });
          }
        }
      }
    } finally {
      this.dashboardRequestInFlight = false;
    }
  }

  componentDidUpdate = prevProps => {
    const prevStatus = prevProps?.myStatus;
    const currentStatus = this.props?.myStatus;

    const restaurantChanged =
      prevStatus?.restaurant_name !== currentStatus?.restaurant_name ||
      prevStatus?.restaurantSelected !== currentStatus?.restaurantSelected ||
      prevStatus?.restaurant_global_id !== currentStatus?.restaurant_global_id;

    if (restaurantChanged) {
      this.setState({ superSetReports: undefined, loggedIn: undefined }, () => {
        if (!this.dashboardRequestInFlight) {
          this.getDashboards();
        }
      });
    }

    if (currentStatus?.sessionId && prevStatus?.sessionId !== currentStatus?.sessionId) {
      startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
    }
  }

  componentDidMount = () => {
    this.getDashboards();
    if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);

    get("superadminService/getAllReports").done(data => {
      this.setState({ reports: data });
    })

    if (typeof localStorage.tableOccupations_timestamp === undefined || (new Date().getTime() - Number(localStorage.tableOccupations_timestamp)) > 1000 * 3600 * 8) {
      localStorage.tableOccupations_toDate = new Date().getTime();
      localStorage.tableOccupations_fromDate = new Date().getTime() - 1000 * 3600 * 24 * 1;
      localStorage.tableOccupations_timestamp = new Date().getTime();
    }
    localStorage.tableOccupations_timestamp = new Date().getTime();

  }

  render() {
    const { admin_local, features } = this.props;
    const background = "#847556";
    const isShopMode = auth?.myStatus?.restaurant_settings?.["shop-mode"];
    if (admin_local)
      return (
        <Switch>
          <Route path="/reportsMenu/dailyClosing" render={props => <DailyClosing {...props} />} />
          <Route path="/reportsMenu/tableOccupations" render={props => <TableOccupations {...props} />} />
          <Route path="/reportsMenu/orderSummary" render={props => <OrderSummary {...props} />} />
          <Route path="/reportsMenu/report/:report" render={props => <Report {...props} />} />
          <Route path="/reportsMenu/menuChangeLog" render={props => <MenuChangeLog {...props} />} />
          <Route path="/reportsMenu" render={props => (
            <div className="mainMenuWrap" style={{ flexGrow: 1, display: "flex", flexFlow: "column" }}>
              <SubmenuHeader {...this.props} header={admin_local.menus.reports} />
              <CanAccess resource="reports">
                <div className="mainMenuGrid" style={{ flexGrow: 1 }}>
                  <CanAccess resource="reports.dailyclosing">
                    <MenuButton backgroundImage={require("../../img/menu-new/activity.svg")} href="/reportsMenu/dailyClosing" i="i_income" background={background} name={admin_local.daily_closing} myStatus={this.props.myStatus}></MenuButton>
                  </CanAccess>
                  <CanAccess resource="reports.tableoccupations">
                    <MenuButton backgroundImage={require("../../img/menu-new/users.svg")} href="/reportsMenu/tableOccupations" i="icon-list" background={background} name={admin_local.orders} myStatus={this.props.myStatus}></MenuButton>
                  </CanAccess>
                  <CanAccess resource={["administration.menuchangelog", "administration.products.fullaccess"]}>
                    <MenuButton backgroundImage={require("../../img/menu-new/menu-change-log.svg")} href="/reportsMenu/menuChangeLog" i="icon-history" background={background} name={admin_local.menus.menuChangeLog} myStatus={this.props.myStatus}></MenuButton>
                  </CanAccess>
                  <CanAccess resource="reports.prebookedorders">
                    {features && (features.pickup.enabled || features.homedelivery.enabled) ?
                      <MenuButton backgroundImage={require("../../img/menu-new/clock.svg")} href="/reportsMenu/orderSummary" i="icon-clock" background={background} name={admin_local.menus.orders} myStatus={this.props.myStatus}></MenuButton>
                      : null
                    }
                  </CanAccess>
                  <CanAccess resource="reports.todaytraffic">
                    <MenuButton backgroundImage={require("../../img/menu-new/bar-chart-2.svg")} href="/reportsMenu/report/todaytraffic" i="i_pending_turnover" background={background} name={admin_local.menus.todaytraffic} myStatus={this.props.myStatus}></MenuButton>
                  </CanAccess>
                  <CanAccess resource="reports.traffic">
                    <MenuButton backgroundImage={require("../../img/menu-new/bar-chart-2.svg")} href="/reportsMenu/report/traffic" i="i_pending_turnover" background={background} name={admin_local.menus.traffic} myStatus={this.props.myStatus}></MenuButton>
                  </CanAccess>
                  <CanAccess resource="reports.menuitems">
                    <MenuButton backgroundImage={require("../../img/menu-new/package.svg")} href="/reportsMenu/report/menuItems" i="i_menu" background={background} name={admin_local.menus.products} myStatus={this.props.myStatus}></MenuButton>
                  </CanAccess>
                  {isShopMode && (
                    <CanAccess resource="reports.pricetags">
                      <MenuButton backgroundImage={require("../../img/menu-new/admin-tag.svg")} href="/reportsMenu/report/pricetags" i="i_label" background={background} name={admin_local.menus.pricetags} myStatus={this.props.myStatus}></MenuButton>
                    </CanAccess>
                  )}
                  {this.state.reports.filter(r => r).map(r =>
                    <CanAccess resource={"reports." + r}>
                      <MenuButton backgroundImage={require("../../img/menu-new/bar-chart-2.svg")} href={"/reportsMenu/report/" + r.name} i="i_menu" background={background} name={r.name} myStatus={this.props.myStatus}></MenuButton>
                    </CanAccess>
                  )}
                  {this.state?.superSetReports?.length > 0 && (
                    this.state.superSetReports.filter(r => r).map(r =>
                      <CanAccess resource={"reports.bi." + r.slug.split("_")[1]}>
                        <MenuButton style={{ background: "blue" }} href={"/reportsMenu/dashboard/" + r.slug} i="i_report" background={background} name={r.name} myStatus={this.props.myStatus}>{r.dashboard_title.split(" - ")[1]}</MenuButton>
                      </CanAccess>
                    )
                  )}
                  <CanAccess resource={"reports.bi"}>
                    <MenuButton style={{ background: "blue" }} href="https://superset.eatwithme.online" i="i_report" background={background} external={true} name={admin_local.menus.bi} myStatus={this.props.myStatus}></MenuButton>
                  </CanAccess>
                </div>
              </CanAccess>
            </div>)
          } />
        </Switch >
      );
    else return null;
  }
}

const mapStateToProps = state => {
  return {
    myStatus: state.rootReducer.myStatus,
    admin_local: state.rootReducer.admin_local,
    local: state.rootReducer.local,
    features: state.rootReducer.myStatus.restaurant_settings ? state.rootReducer.myStatus.restaurant_settings["enabled-features"] : undefined
  };
};

export default connect(mapStateToProps)(ReportsMenu);
